module.exports = __webpack_public_path__ + "assets/img/reception_logo.3e58ac89.png";